// src/services/termsDataService.js
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { Capacitor } from "@capacitor/core";
import { FirebaseFirestore } from "@capacitor-firebase/firestore";
import { db } from "../firebase";

export const TERMS_VERSION = "2026-06-ugc-v1";

export const acceptTermsForUserData = async (uid, email = "") => {
  const cleanUid = String(uid || "").trim();

  if (!cleanUid) {
    throw new Error("missing-uid");
  }

  const payload = {
    termsAccepted: true,
    termsAcceptedAtClient: new Date().toISOString(),
    termsVersion: TERMS_VERSION,
    updatedAtClient: new Date().toISOString(),
  };

  if (email) {
    payload.email = String(email || "").trim().toLowerCase();
  }

  if (Capacitor.isNativePlatform()) {
    await FirebaseFirestore.setDocument({
      reference: `nutzer/${cleanUid}`,
      data: payload,
      merge: true,
    });

    return { ok: true };
  }

  await setDoc(
    doc(db, "nutzer", cleanUid),
    {
      ...payload,
      termsAcceptedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  return { ok: true };
};